import polyfillArrayAt from './arrayAt';
import polyfillWithResolvers from './withResolvers';

(() => {
  polyfillWithResolvers();
  polyfillArrayAt();
})();
